import React from 'react';
import stripeLogoPath from './stripe-logo.svg';
import styled, { css } from 'styled-components';
const StripeLogoStyled = styled.img(() => {
    return css({
        height: '23px',
        position: 'relative',
        top: '3px'
    });
});
const StripeLogo = React.createElement(StripeLogoStyled, { src: stripeLogoPath, alt: 'Stripe' });
export default StripeLogo;
